import { Avatar as MuiAvatar, styled, Menu, MenuItem, Typography, alpha } from '@mui/material';

export const ProfileBox = styled('div')<{ isSubstituting?: boolean }>(({ theme, isSubstituting }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '4px 8px 4px 4px',
  borderRadius: '14px',
  cursor: 'pointer',
  border: `1px solid ${isSubstituting ? theme.palette.error.main : alpha(theme.palette.text.primary, 0.08)}`,
  backgroundColor: isSubstituting ? alpha(theme.palette.error.main, 0.08) : 'transparent',
  transition: 'background-color 120ms ease, border-color 120ms ease',
  ':hover': {
    backgroundColor: isSubstituting ? alpha(theme.palette.error.main, 0.12) : alpha(theme.palette.text.primary, 0.04),
  },
}));

export const ProfileWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
});

export const Avatar = styled(MuiAvatar)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.text.primary, 0.06),
  color: theme.palette.text.primary,
}));

export const ProfileName = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '4rem',
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    maxHeight: '80%',
    marginTop: '8px',
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
  },
}));

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  gap: '12px',
  width: '100%',
  fontSize: '13px',
});

export const StyledMenuItemIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: alpha(theme.palette.text.primary, 0.06),
  padding: '4px',
  borderRadius: '8px',
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  },
}));

export const GreetingHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  margin: '10px 12px',
  padding: '10px 12px',
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  borderRadius: '12px',
}));

export const GreetingAvatar = styled(MuiAvatar)(({ theme }) => ({
  width: '36px',
  height: '36px',
  backgroundColor: alpha(theme.palette.primary.main, 0.12),
  color: theme.palette.primary.main,
  fontSize: '15px',
  fontWeight: 600,
}));

export const GreetingName = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.text.primary,
  lineHeight: 1.3,
}));
